import {AxiosRequestConfig} from 'axios';
import request from '../../axios';

const getBuyersList = async (payload: IBuyerParams) => {
  const {data}: {data: IBuyersList} = await request.get(
    'api/v2/wanted/supplier-shop-requirements-list',
    {
      params: payload,
    } as AxiosRequestConfig,
  );
  return data;
};

export default getBuyersList;
